<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_apartment_receipt')"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>
          <div class="box-body">
            <div class="col-sm-3 col-md-3 col-lg-3">
              <div class="form-group">
                <!-- <date-picker
                  :config="options"
                  v-model="search.startTime"
                  @dp-change="onChangeStartTime(search.startTime)"
                ></date-picker> -->
                <div class="input-group date">
                  <date-picker
                    :config="options"
                    v-model="search.searchDate"
                  ></date-picker>
                  <div class="input-group-addon">
                    <i class="fa fa-calendar"> </i>
                  </div>
                </div>
              </div>
            </div>
            <div style="padding: 0 15px">
              <div class="form-group">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button
                    v-for="(item, index) in roomPerformanceReportDateList"
                    :key="item + index"
                    type="button"
                    class="btn btn-primary"
                    @click="onChangeNumberDate(item.value)"
                  >
                    {{ $t(item.text) }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;"
            >
              <b>{{ $t("apartmentType.title") }}</b>
            </div>
          </div>
          <div class="box-body">
            <div class="table-class">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">{{ $t("apartmentType.title") }}</th>
                    <th
                      scope="col"
                      v-for="(itemDate, index) in headerTable.data_list"
                      :key="itemDate + index"
                    >
                      {{ formatDate(itemDate, "DD-MM-YYYY", "DD/MM") }}
                      <p style="margin: 0">{{ getDayEnName(itemDate) }}</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(itemTable, index) in itemTable"
                    :key="itemTable + index"
                  >
                    <th scope="row">{{ $t(itemTable.text) }}</th>
                    <td
                      v-for="(dataListItem, index) in itemTable.data_list"
                      :key="`${dataListItem}${index}`"
                    >
                      <span
                        v-if="
                          itemTable.text ===
                            'roomPerformanceReport.occupancyRate'
                        "
                        >{{ dataListItem }}%</span
                      >
                      <span v-else>{{ dataListItem }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from '@/lib/utils';
import constantsData from "@/lib/constantsData";
import Loading from "vue-loading-overlay";
import datePicker from "vue-bootstrap-datetimepicker";
import moment from "moment";

export default {
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker,
    loading: Loading
  },
  data() {
    return {
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      search: {
        searchDate: null,
        numberDateSelect: 7
      },
      roomPerformanceReportDateList:
        constantsData.roomPerformanceReportDateList,
      //
      headerTable: [],
      itemTable: [],
      //
      isLoading: false
    };
  },
  watch: {
    GET_ROOM_PERFORMANCE_REPORT_DATA: function() {
      let data = this.GET_ROOM_PERFORMANCE_REPORT_DATA;
      let headerTable = data[0];
      this.headerTable = headerTable;
      // this.headerTable = {
      //   text: headerTable.text,
      //   data_list: []
      // };
      //
      // headerTable.data_list.forEach(data => {
      //   let item = utils.formatSqlDate(data, "DD-MM-YYYY", "DD/MM");
      //   this.headerTable.data_list.push(item);
      // });
      // console.log(this.headerTable.data_list);
      // item table
      this.itemTable = [];
      let dataClone = [...data];
      let resultList = dataClone.splice(1, data.length);
      this.itemTable = resultList;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_ROOM_PERFORMANCE_REPORT_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    getRoomPerformanceReportList: function() {
      let filter = {
        params: {
          dateSearch: this.search.searchDate,
          numberDate: this.search.numberDateSelect
        }
      };
      this.isLoading = true;
      this.GET_ROOM_PERFORMANCE_REPORT(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onChangeNumberDate: function(value) {
      this.search.numberDateSelect = value;
      this.getRoomPerformanceReportList();
    },
    getDayEnName: function(date) {
      let dateFormat = utils.formatSqlDate(date, "DD-MM-YYYY", "ddd");
      return dateFormat;
    },
    formatDate: function(date, formFormat, toFormat) {
      let resultData = utils.formatSqlDate(date, formFormat, toFormat);
      return resultData;
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_ROOM_PERFORMANCE_REPORT"
    ])
  },
  mounted() {
    this.search.searchDate = moment().format("DD/MM/YYYY");
    this.getRoomPerformanceReportList();
  }
};
</script>
<style scoped>
.table-class {
  display: flex;
  overflow: auto;
  overflow-x: scroll;
  margin-bottom: 10px;
}
.table-class table th:first-child {
  left: 0;
  background: #eceff0;
  text-overflow: ellipsis;
  overflow: hidden;
}
.table-class table {
  border-collapse: separate;
  border-spacing: 0;
}
.table-class thead th {
  padding: 15px 5px;
  background: #f4f3f8;
  font-size: 14px;
  border: none;
  color: #575962;
  max-width: 50px;
  min-width: 50px;
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
  z-index: 998;
  border-right: 1px solid #dddddd;
  text-align: center;
}
.table-class thead th:first-child {
  left: 0;
  z-index: 999;
}
.table-class tbody th {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  left: 0;
  background: #fff;
  border-right: 1px solid #dddddd;
  white-space: nowrap;
}
.table-class th {
  border-bottom: solid #ddd 1px;
}

.table-class tbody td {
  border-right: 1px solid #dddddd;
  text-align: center;
  align-items: center;
  vertical-align: inherit;
}

.table-class tbody tr:hover {
  background: #8fd19e;
}
/*  */
</style>



// WEBPACK FOOTER //
// src/views/Report/RoomPerformanceReport.vue